import { FC } from "react";

const LogoDetail: FC<any> = () => {
  return (
    <svg
      id="Camada_1"
      data-name="Camada 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 444.99"
      style={{ width: 125 }}
    >
      <defs>
        <style>{`.cls-1{fill: #fff}`}</style>
      </defs>
      <title>LOGo BIZ [Recovered]</title>
      <path
        className="cls-1"
        d="M268.13,252.43H246.85V234.9h21.28Zm-21.28,12h21.28v77.46H246.85Z"
      />
      <path
        className="cls-1"
        d="M280.11,325.84l40.3-45.4h-37.3v-16h65.32v16l-40.3,45.4h43.14v16H280.11Z"
      />
      <path
        className="cls-1"
        d="M388.58,254.68H356.52V234.9h87.64v19.78H412.1v87.19H388.58Z"
      />
      <path
        className="cls-1"
        d="M440.42,264.41h20.22V278.8h.3a25.71,25.71,0,0,1,9.89-11.91,26.3,26.3,0,0,1,14.83-4.57,17.79,17.79,0,0,1,4.65.75v19.77a34.74,34.74,0,0,0-7.64-.75q-21,0-21,24.87v34.91H440.42Z"
      />
      <path
        className="cls-1"
        d="M513.53,308.31q.45,10.19,5.17,14.91t13.86,4.72a19.79,19.79,0,0,0,10.93-3.07q4.8-3.08,5.85-7h18.72q-8.38,25.92-36.25,25.92-18.13,0-28.84-11.16t-10.71-29.44q0-17.69,11-29.29t28.54-11.61q18.87,0,28.91,13.48t8.69,32.51Zm34.61-13.48q-1.5-8.4-5.47-12.44t-11.46-4q-9.15,0-13.19,5.17a20.48,20.48,0,0,0-4.49,11.31Z"
      />
      <path
        className="cls-1"
        d="M581.1,288.24q.9-13.64,11.23-19.78t25.17-6.14q34,0,34,22v40.3q0,12.89,2.7,17.23H632.64a29.07,29.07,0,0,1-1.5-7.49q-9,9.44-26.07,9.44-11.84,0-19.1-5.77t-7.27-17.3q0-8.25,4-13.49a19.28,19.28,0,0,1,9.74-7,103.47,103.47,0,0,1,12.51-3,116.63,116.63,0,0,1,12.43-1.57,21.64,21.64,0,0,0,9.37-2.47,6.4,6.4,0,0,0,3.52-6.14q0-6.15-3.6-8.32t-10.18-2.17q-13.05,0-14.09,11.69ZM630.24,304a11,11,0,0,1-3.45,1.87,22.3,22.3,0,0,1-4.12,1.12c-1.25.21-3,.45-5.17.75s-3.84.55-4.94.75a21.63,21.63,0,0,0-9.29,3.52q-3.3,2.47-3.3,7.87,0,9.88,13,9.89,17.22,0,17.23-17.83Z"
      />
      <path
        className="cls-1"
        d="M684.47,316.7q0,6.45,4.8,9.74a19.82,19.82,0,0,0,11.53,3.3,19.4,19.4,0,0,0,9.67-2.4,8,8,0,0,0,4.27-7.49q0-4.5-5.55-6.89t-18.58-5.1a72.52,72.52,0,0,1-9.21-2.54,45.54,45.54,0,0,1-7.57-3.68,15.46,15.46,0,0,1-5.84-5.91,17.69,17.69,0,0,1-2-8.54,24.49,24.49,0,0,1,2.85-12.14,19.41,19.41,0,0,1,7.87-7.79,38.07,38.07,0,0,1,10.63-3.82,63.18,63.18,0,0,1,12.37-1.12q14.22,0,23.59,5.76t10.56,19H713.69q-.75-10.49-14.53-10.49-11.85,0-11.84,7.19a6.14,6.14,0,0,0,.67,2.92,6.37,6.37,0,0,0,2.1,2.25,18.9,18.9,0,0,0,2.92,1.65,27.71,27.71,0,0,0,4,1.35c1.65.45,3.1.82,4.35,1.12s2.92.67,5,1.12,3.79.83,5.09,1.13q11.53,2.69,18,7.34T736,317a26.19,26.19,0,0,1-3,12.81,20.87,20.87,0,0,1-8.16,8.39,40.77,40.77,0,0,1-11.16,4.27,59.34,59.34,0,0,1-13,1.35,60.09,60.09,0,0,1-17.38-2.32,28.1,28.1,0,0,1-13.18-8.69q-5.55-6.37-5.84-16.11Z"
      />
      <path
        className="cls-1"
        d="M821.11,341.87H800.88V331.08h-.45q-7.63,12.74-23.67,12.74t-22.17-8q-6.15-8-6.15-23.74V264.41h21.28v43.75q0,9.88,3.07,14.46t10.56,4.57q8.68,0,12.59-5.24T799.83,305V264.41h21.28Z"
      />
      <path
        className="cls-1"
        d="M837.28,264.41h20.23V278.8h.3a25.65,25.65,0,0,1,9.89-11.91,26.3,26.3,0,0,1,14.83-4.57,17.79,17.79,0,0,1,4.65.75v19.77a34.77,34.77,0,0,0-7.65-.75q-21,0-21,24.87v34.91H837.28Z"
      />
      <path
        className="cls-1"
        d="M910.4,308.31q.45,10.19,5.17,14.91t13.86,4.72a19.81,19.81,0,0,0,10.93-3.07q4.8-3.08,5.85-7h18.72q-8.38,25.92-36.25,25.92-18.13,0-28.84-11.16t-10.72-29.44q0-17.69,11-29.29t28.54-11.61q18.87,0,28.91,13.48t8.69,32.51ZM945,294.83q-1.5-8.4-5.47-12.44t-11.46-4q-9.15,0-13.19,5.17a20.48,20.48,0,0,0-4.49,11.31Z"
      />
      <path
        className="cls-1"
        d="M223.13,149.31,183.86,97.37a10.46,10.46,0,0,0-8.33-4.15H44a10.44,10.44,0,0,0-10.43,10.44V333.39A10.43,10.43,0,0,0,44,343.82H175.53a10.46,10.46,0,0,0,8.33-4.15l39.33-52.11a10.43,10.43,0,0,0-.09-12.68l-39.26-50.52a10.44,10.44,0,0,1,.06-12.88L223,162.08A10.43,10.43,0,0,0,223.13,149.31ZM170.49,287.73l-9.16,9.93a10.48,10.48,0,0,1-7.67,3.35H88.22a10.43,10.43,0,0,1-10.43-10.43V144.45A10.43,10.43,0,0,1,88.22,134h64.2a10.42,10.42,0,0,1,7.78,3.48l10.49,11.73a10.42,10.42,0,0,1,.43,13.4l-38.88,49.44a10.42,10.42,0,0,0,0,12.9L171,274.19A10.43,10.43,0,0,1,170.49,287.73Z"
      />
    </svg>
  );
};

export default LogoDetail;
